import React from 'react';
import { Button } from 'react-bootstrap';
import type { OnboardingStepId } from '../../models/organization';
import { getStepMeta } from './onboardingCopy';
import InventorySuccessMock from './mocks/InventorySuccessMock';
import ClientSuccessMock from './mocks/ClientSuccessMock';
import OrdersSuccessMock from './mocks/OrdersSuccessMock';
import photoCity from '../../assets/onboarding/city-blur.png';
import photoOrganic from '../../assets/onboarding/organic.jpg';
import photoHand from '../../assets/onboarding/hand-phone.png';
import styles from './OnboardingEmptyHero.module.scss';

type Props = {
  stepId: OnboardingStepId;
  onPrimary: () => void;
  primaryLabel?: string;
};

const PHOTO_BY_STEP: Partial<Record<OnboardingStepId, string>> = {
  product: photoOrganic,
  client: photoCity,
  order: photoHand,
  approve: photoHand,
  intro: photoCity,
  done: photoOrganic,
};

const OnboardingEmptyHero: React.FC<Props> = ({
  stepId,
  onPrimary,
  primaryLabel,
}) => {
  const meta = getStepMeta(stepId);
  const photo = PHOTO_BY_STEP[stepId] ?? photoCity;

  let mock: React.ReactNode = null;
  if (stepId === 'product') mock = <InventorySuccessMock />;
  else if (stepId === 'client') mock = <ClientSuccessMock />;
  else if (stepId === 'order') mock = <OrdersSuccessMock highlightApprove />;
  else if (stepId === 'approve')
    mock = <OrdersSuccessMock highlightApprove />;
  else mock = <InventorySuccessMock />;

  const isApprove = stepId === 'approve';

  return (
    <section
      key={stepId}
      className={styles.hero}
      aria-label={meta.title}
    >
      <div
        className={styles.photo}
        style={{ backgroundImage: `url(${photo})` }}
      />
      <div className={styles.photoWash} />
      <div className={styles.copy}>
        <p className={styles.eyebrow}>Configuración guiada</p>
        <h2 className={styles.title}>{meta.title}</h2>
        <p className={styles.why}>{meta.why}</p>
        <div className={styles.actions}>
          <Button
            variant={isApprove ? 'warning' : 'primary'}
            className={isApprove ? styles.ctaPulse : undefined}
            onClick={onPrimary}
          >
            {primaryLabel ?? meta.cta}
          </Button>
        </div>
      </div>
      <div className={styles.visual}>{mock}</div>
    </section>
  );
};

export default OnboardingEmptyHero;
